export { BookingsTableHead } from './BookingsTableHead'


// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingsTableHead/index.js